var React = require('react');

function FacebookRound (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"nonzero","d":"M77 0C34.477 0 0 34.477 0 77s34.477 77 77 77 77-34.477 77-77S119.523 0 77 0zm19.25 51.333h-8.662c-3.453 0-4.171 1.418-4.171 4.992v7.842H96.25L94.909 77H83.417v44.917h-19.25V77H51.333V64.167h12.834v-14.81c0-11.351 5.974-17.274 19.436-17.274H96.25v19.25z"}));
}

FacebookRound.defaultProps = {"viewBox":"0 0 154 154"};

module.exports = FacebookRound;

FacebookRound.default = FacebookRound;
